import {computed, makeObservable, observable} from 'mobx'

export class DateTimezoneState {
    @observable private _customerTimezoneSelected = false

    private localStorageKey = 'show-datetime-in-timezone'
    private showInCustomerTimezone = 'customer'
    private showInLocalTimezone = 'local'

    constructor() {
        this.customerTimezoneSelected = this.getCustomerTimezoneSelectedFromLocalStorage()
        makeObservable(this)
    }

    @computed
    public get customerTimezoneSelected() {
        return this._customerTimezoneSelected
    }

    public set customerTimezoneSelected(value) {
        localStorage.setItem(this.localStorageKey, value ? this.showInCustomerTimezone : this.showInLocalTimezone)
        this._customerTimezoneSelected = value
    }

    private getCustomerTimezoneSelectedFromLocalStorage(): boolean {
        return localStorage.getItem(this.localStorageKey) === this.showInCustomerTimezone
    }
}
